import { Toaster as Sonner, toast } from 'sonner';

/**
 * Toasts are a floating layer (tooltip elevation). Unstyled sonner with DESIGN.md tokens;
 * sonner provides the `aria-live` region. Tone is carried by the text (and a coloured
 * border), never by colour alone.
 */
export function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      visibleToasts={4}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex w-[min(360px,calc(100vw-32px))] items-start gap-2 rounded-lg border border-[var(--line)] bg-[var(--surface)] px-4 py-3 text-sm text-[var(--ink)] shadow-[var(--shadow-tooltip)]',
          title: 'font-medium',
          description: 'mt-0.5 font-mono text-xs text-[var(--ink-faint)]',
          success: 'border-[var(--positive)]',
          error: 'border-[var(--negative)] text-[var(--negative)]',
          warning: 'border-[var(--warning)]',
          actionButton:
            'ml-auto h-8 shrink-0 rounded-md border border-[var(--line)] px-2 text-xs font-medium',
        },
      }}
    />
  );
}

export { toast };
